export const iso = (d) => d.toISOString().slice(0, 10);
const utc = (y, m, d) => new Date(Date.UTC(y, m, d));

export function presets() {
  const t = new Date();
  const [y, m, d] = [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()];
  const today = iso(utc(y, m, d));
  return [
    ["month", "Questo mese", iso(utc(y, m, 1)), today],
    ["last-month", "Mese scorso", iso(utc(y, m - 1, 1)), iso(utc(y, m, 0))],
    ["7d", "Ultimi 7 giorni", iso(utc(y, m, d - 6)), today],
    ["30d", "Ultimi 30 giorni", iso(utc(y, m, d - 29)), today],
    ["year", "Da inizio anno", iso(utc(y, 0, 1)), today],
  ];
}

export function daysBetween(start, end) {
  const out = [];
  for (let d = new Date(`${start}T00:00:00Z`); iso(d) <= end && out.length < 400; d = new Date(d.getTime() + 86400000)) out.push(iso(d));
  return out;
}

export const fmtDay = (s) => new Date(`${s}T00:00:00Z`).toLocaleDateString("it-IT", { day: "numeric", month: "short", timeZone: "UTC" });
export const fmtMonth = (s) => new Date(`${s}-01T00:00:00Z`).toLocaleDateString("it-IT", { month: "short", year: "2-digit", timeZone: "UTC" });
export const fmtN = (v) => Number(v || 0).toLocaleString("it-IT");
export const pl = (n, one, many) => `${fmtN(n)} ${n === 1 ? one : many}`;

export const STATUS = {
  running: ["In corso", "bg-sky-50 text-sky-700 border-sky-200"], done: ["Completata", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  cancelled: ["Interrotta", "bg-amber-50 text-amber-800 border-amber-200"], error: ["Errore", "bg-red-50 text-red-700 border-red-200"],
};
export const SOURCES = { universal: "Universal Key", own: "Chiave personale" };
